  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('.customer-support-form');
    if (!form) return;
    const translations = JSON.parse(document.getElementById('customer-support-translations').textContent);
    const messages = window.frontendMessages || {};
    const nameFields = [];
    let submitting = false;
    let supportType = 'presales';
    function trackSupport(action) {
      // Use Clarity's standard queue so early interactions survive its delayed loader.
      try {
        window.clarity = window.clarity || function () {
          (window.clarity.q = window.clarity.q || []).push(arguments);
        };
        window.clarity('event', 'customer_support_' + action);
        window.clarity('event', 'customer_support_' + supportType + '_' + action);
      } catch (error) {}
    }
    const supportPage = form.closest('.customer-support-page');
    function trackSupportLink(event) {
      if (event.type === 'auxclick' && event.button !== 1) return;
      const link = event.target.closest('a');
      if (!link) return;
      if (link.matches('.customer-support-page__app-help, .support-sn-help__trigger')) {
        trackSupport(link.matches('.support-sn-help__trigger') ? 'sn_help_click' : 'app_help_click');
        // This records the opening action, not completion of a cross-origin PDF load.
        trackSupport('pdf_open');
      } else if (link.matches('.customer-support-page__app-download')) {
        trackSupport('app_download_click');
      }
    }
    supportPage.addEventListener('click', trackSupportLink);
    supportPage.addEventListener('auxclick', trackSupportLink);
    const copy = {
      contact: translations.contact_title,
      question: translations.question,
      issue: translations.issue_description,
      sn: translations.sn_error,
      snNotFound: translations.sn_not_found,
      snUnavailable: translations.sn_validation_failed,
      consent: translations.consent_error,
      required: translations.required_error,
      tooLong: translations.too_long,
      failed: translations.failed
    };
    const supportSelectors = [];
    [
      ['supportPurchaseChannel', [
        { value: 'STRUTT', label: 'Strutt' },
        { value: 'AUTHORIZED_DEALER', label: translations.authorized_dealer }
      ]],
      ['supportIssueType', [
        { value: 'DELIVERY_DELAY_OR_NON_DELIVERY', label: translations.delivery },
        { value: 'SHIPPING_DAMAGE', label: translations.damage },
        { value: 'PRODUCT_ISSUE', label: translations.product_issue }
      ]]
    ].forEach(([id, options]) => {
      const selector = document.getElementById(id);
      const toggle = selector.querySelector('.component-filter__state-layer');
      const value = selector.querySelector('input[type="hidden"]');
      if (window.initComponentSelector) {
        const api = window.initComponentSelector(selector, options, () => {
          toggle.removeAttribute('aria-invalid');
          value.removeAttribute('aria-invalid');
          value.dispatchEvent(new Event('input', { bubbles: true }));
        });
        supportSelectors.push({ api, input: value });
      }
    });
    // ZIP Code 校验函数（从 Take a Drive 同步）
    function validateZipCode(zipCodeField) {
      if (!zipCodeField || zipCodeField.disabled) return;
      
      const zipCodeValue = zipCodeField.value?.trim() || '';
      // 使用 validator 进行格式校验（基于国家选择器的 ISO2 国家码；兜底用 any）
      if (zipCodeValue.length > 0) {
        const countrySelectorEl = form.querySelector('#customerSupportCountry');
        const iso2 = (countrySelectorEl && countrySelectorEl.getAttribute('data-country-code')) ? countrySelectorEl.getAttribute('data-country-code') : '';
        let isValid = true;

        if (window.validator && typeof window.validator.isPostalCode === 'function') {
          try {
            isValid = window.validator.isPostalCode(zipCodeValue, iso2 || 'any');
          } catch (e) {
            // locale 不支持时 fallback
            try {
              isValid = window.validator.isPostalCode(zipCodeValue, 'any');
            } catch (err) {
              isValid = true;
            }
          }
        }

        if (!isValid) {
          if (window.showTextInputError) {
            window.showTextInputError(messages.invalidZipCode, zipCodeField);
          }
          return;
        }
      }

      // 清除错误
      if (window.hideTextInputError) {
        window.hideTextInputError(zipCodeField);
      }
    }

    // 名字字段验证函数（仅允许字母）
    function validateNameField(field) {
      if (!field) {
        return true;
      }
      const trimmedValue = (field.value || '').trim();

      // 空值：清除错误，不提示
      if (!trimmedValue) {
        if (window.hideTextInputError) {
          window.hideTextInputError(field);
        } else if (window.TextInputComponent && typeof window.TextInputComponent.clearError === 'function') {
          window.TextInputComponent.clearError(field);
        }
        return true;
      }

      // 合法非空：清除错误
      if (window.hideTextInputError) {
        window.hideTextInputError(field);
      } else if (window.TextInputComponent && typeof window.TextInputComponent.clearError === 'function') {
        window.TextInputComponent.clearError(field);
      }
      return true;
    }

    if (form) {
      // 监听国家选择器的 change 事件，选中后清除错误、同步区号并重新校验邮编
      const countrySelector = form.querySelector('#customerSupportCountry');
      if (countrySelector) {
        const phoneGroup = form.querySelector('[data-component="phone-with-dialcode"]');
        const dialcodeContainer = phoneGroup ? phoneGroup.querySelector('[data-component="dialcode-selector"]') : null;
        const EU_ISO2 = ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'];
        function setZipLabelText(text) {
          const zipWrap = form.querySelector('.customer-support-form__zip');
          if (!zipWrap) return;
          const labelEl = zipWrap.querySelector('.component-text-input__label');
          if (!labelEl) return;
          const star = labelEl.querySelector('.component-text-input__required');
          labelEl.textContent = text;
          if (star) labelEl.appendChild(star);
        }
        function updateZipLabelByCountryCode(iso2) {
          const code = String(iso2 || '').toUpperCase();
          if (code === 'US') {
            setZipLabelText('Zip Code');
            return;
          }
          if (code === 'GB') {
            setZipLabelText('Post Code');
            return;
          }
          if (code === 'SG' || EU_ISO2.indexOf(code) !== -1) {
            setZipLabelText('Postal Code');
            return;
          }
          if (!code) {
            setZipLabelText('Zip Code');
            return;
          }
          setZipLabelText('Postal Code');
        }

        countrySelector.addEventListener('countryChanged', function(e) {
          // 清除国家选择器错误
          countrySelector.classList.remove('component-country-selector--error');
          const errorElement = countrySelector.querySelector('.component-country-selector__error');
          if (errorElement) {
            errorElement.style.display = 'none';
          }
          
          // 确保 data-country-code 被设置（从事件中获取 iso2）
          if (e.detail && e.detail.iso2) {
            countrySelector.setAttribute('data-country-code', e.detail.iso2);
          }

          if (dialcodeContainer && e.detail && e.detail.iso2 && window.DialCodeSelector) {
            const iso2 = String(e.detail.iso2 || '').toUpperCase();
            const instance = window.DialCodeSelector.getInstance(dialcodeContainer);
            if (instance && typeof instance.selectCountry === 'function') {
              instance.selectCountry(iso2);
            } else if (typeof window.DialCodeSelector.setValue === 'function') {
              window.DialCodeSelector.setValue(dialcodeContainer, iso2);
            }
            dialcodeContainer.classList.remove('component-dialcode-selector--error');
            const dialcodeErrorElement = dialcodeContainer.querySelector('.component-dialcode-selector__error');
            if (dialcodeErrorElement) {
              dialcodeErrorElement.style.display = 'none';
            }
          }

          updateZipLabelByCountryCode(e.detail && e.detail.iso2);
          
          // 如果邮编字段有值，重新校验邮编（因为国家改变了，邮编格式可能不匹配）
          const zipCodeField = form.querySelector('input[name="zipCode"]');
          if (zipCodeField && zipCodeField.value && zipCodeField.value.trim()) {
            validateZipCode(zipCodeField);
          }
        });

        (function initZipLabel() {
          let iso2 = countrySelector.getAttribute('data-country-code') || '';
          if (!iso2) {
            try {
              const regionButtons = document.querySelectorAll('.component-navbar__region-btn');
              let regionText = '';
              regionButtons.forEach(btn => {
                if (regionText) return;
                if (!btn || !btn.textContent) return;
                const style = window.getComputedStyle(btn);
                if (style && style.display === 'none') return;
                regionText = btn.textContent.replace(/\s+/g, ' ').trim().toUpperCase();
              });
              if (regionText === 'US') iso2 = 'US';
              else if (regionText === 'UK') iso2 = 'GB';
              else if (regionText === 'EU') iso2 = 'DE';
              else if (regionText === 'SG') iso2 = 'SG';
            } catch (e) {}
          }
          updateZipLabelByCountryCode(iso2 || 'US');
        })();
      }

      // Zip Code 长度验证（失焦验证）
      const zipCodeField = form.querySelector('input[name="zipCode"]');
      if (zipCodeField) {
        zipCodeField.addEventListener('blur', function (e) {
          // 检查是否点击了清除按钮或密码切换按钮，如果是则跳过验证
          const relatedTarget = e.relatedTarget;
          const isClickingButton = relatedTarget && (
            relatedTarget.closest('.component-text-input__clear-btn') ||
            relatedTarget.closest('.component-text-input__password-toggle') ||
            relatedTarget.closest('.component-text-input__password-icon')
          );
          
          if (isClickingButton) {
            return; // 不处理失焦逻辑
          }
          
          validateZipCode(zipCodeField);
        });
      }

      // 名字字段验证
      ['firstName', 'lastName'].forEach((fieldName) => {
        const field = form.querySelector(`input[name="${fieldName}"]`);
        if (field) {
          nameFields.push(field);
          
          // Focus 事件：清除错误状态
          field.addEventListener('focus', function () {
            if (window.hideTextInputError) {
              window.hideTextInputError(field);
            } else if (window.TextInputComponent && typeof window.TextInputComponent.clearError === 'function') {
              window.TextInputComponent.clearError(field);
            }
            // 清除组件级别的错误状态
            const inputContainer = field.closest('.component-text-input');
            if (inputContainer) {
              inputContainer.classList.remove('component-text-input--error');
              inputContainer.classList.remove('component-text-input--invalid');
            }
            field.classList.remove('component-text-input__field--error');
            field.removeAttribute('aria-invalid');
          });
          
          // blur 校验已由 component-text-input.js 统一处理（包含 XSS 和 SQL 注入检测）
          // input 事件也由 component-text-input.js 统一处理
        }
      });

      // Email 和其他字段的 focus 事件已由 component-text-input.js 统一处理


      // Message Textarea 功能（字符计数和高度变化）
      const messageTextarea = form.querySelector('textarea[name="message"]');
      const messageCounterEl = document.getElementById('customerSupportMessageCounter');
      const phoneGroup = form.querySelector('[data-component="phone-with-dialcode"]');
      const dialcodeInput = phoneGroup ? phoneGroup.querySelector('input[name="areaCode"]') : null;
      const phoneInput = phoneGroup ? (phoneGroup.querySelector('input[name="phone"]') || phoneGroup.querySelector('input[name="phoneNumber"]') || phoneGroup.querySelector('input[type="tel"]')) : null;

      function getPhoneSubmissionData() {
        const rawPhoneNumber = phoneInput?.value?.trim() || '';
        let formatPhone = rawPhoneNumber;
        const dialcodeContainer = phoneGroup ? phoneGroup.querySelector('[data-component="dialcode-selector"]') : null;

        if (
          rawPhoneNumber
          && dialcodeContainer
          && window.DialCodeSelector
          && typeof window.DialCodeSelector.formatPhoneNumber === 'function'
        ) {
          formatPhone = String(window.DialCodeSelector.formatPhoneNumber(dialcodeContainer, rawPhoneNumber) || '').trim() || rawPhoneNumber;
        }

        return {
          rawPhoneNumber,
          formatPhone
        };
      }

      if (messageTextarea && messageCounterEl) {
        function updateMessageCounter() {
          const length = messageTextarea.value.length;
          messageCounterEl.textContent = `${length}/${messageTextarea.maxLength}`;
        }
        
        function updateMessageHeight() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          
          if (messageTextarea.value.trim() !== '') {
            messageTextarea.classList.add('has-content');
          } else {
            messageTextarea.classList.remove('has-content');
          }
          
          const isMobileOrTablet = window.innerWidth <= 1068;
          const minHeight = isMobileOrTablet ? 140 : 167;
          const isFocused = document.activeElement === messageTextarea;
          const hasContent = messageTextarea.classList.contains('has-content');
          
          if (hasContent || isFocused) {
            messageTextarea.style.height = '';
            void messageTextarea.offsetHeight;
            const scrollHeight = messageTextarea.scrollHeight;
            const newHeight = Math.max(minHeight, scrollHeight);
            messageTextarea.style.height = newHeight + 'px';
          } else {
            messageTextarea.style.height = '';
          }
    
          // 使用 requestAnimationFrame 确保在浏览器重排后立即恢复
          requestAnimationFrame(() => {
            window.scrollTo(0, scrollTop);
          });
        }
        
        updateMessageCounter();
        updateMessageHeight();
        
        messageTextarea.addEventListener('input', function () {
          updateMessageCounter();
          updateMessageHeight();
          
          // 清除错误状态
          const messageWrap = messageTextarea.closest('.customer-support-form__message-wrap');
          if (messageWrap) {
            messageWrap.classList.remove('customer-support-form__message-wrap--error');
            const errorElement = messageWrap.querySelector('.customer-support-form__message-error');
            if (errorElement) {
              errorElement.style.display = 'none';
            }
          }
        });
        
        messageTextarea.addEventListener('focus', function () {
          updateMessageHeight();
          
          // 清除错误状态
          const messageWrap = messageTextarea.closest('.customer-support-form__message-wrap');
          if (messageWrap) {
            messageWrap.classList.remove('customer-support-form__message-wrap--error');
            const errorElement = messageWrap.querySelector('.customer-support-form__message-error');
            if (errorElement) {
              errorElement.style.display = 'none';
            }
          }
        });
        
        messageTextarea.addEventListener('blur', updateMessageHeight);
        
        let resizeTimer;
        window.addEventListener('resize', function() {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(updateMessageHeight, 100);
        });
      }

      const tabs = Array.from(document.querySelectorAll('[data-support-type]'));
      const contactSection = form.querySelector('[data-support-contact]');
      const issueSection = form.querySelector('[data-support-issue]');
      const messageSection = form.querySelector('[data-support-message]');
      const draftFields = Array.from(form.querySelectorAll('input, select, textarea'));
      const dialcodeContainer = phoneGroup?.querySelector('[data-component="dialcode-selector"]');
      const getDialcodeInstance = () => dialcodeContainer && window.DialCodeSelector?.getInstance(dialcodeContainer);
      function captureDraft() {
        const dialcode = getDialcodeInstance();
        return {
          fields: draftFields.map(field => ({ value: field.value, checked: field.checked })),
          countryCode: countrySelector?.getAttribute('data-country-code') || '',
          dialcode: dialcode ? { country: dialcode.currentCountry, selected: dialcode.isSelected } : null
        };
      }
      const emptyDraft = captureDraft();
      const drafts = { presales: emptyDraft, aftersales: emptyDraft };
      function restoreDraft(draft) {
        // Restore component state as well as values: country and calling code may differ.
        draftFields.forEach((field, index) => {
          field.value = draft.fields[index].value;
          field.checked = draft.fields[index].checked;
        });
        if (countrySelector) {
          if (draft.countryCode) countrySelector.setAttribute('data-country-code', draft.countryCode);
          else countrySelector.removeAttribute('data-country-code');
          countrySelector.classList.remove('expanded', 'component-country-selector--error');
          countrySelector.style.setProperty('--component-country-selector-expanded-space', '0px');
          countrySelector.closest('.root-content')?.style.setProperty('--root-content-country-selector-expanded-space', '0px');
          countrySelector.classList.toggle('has-value', Boolean(draft.countryCode));
          countrySelector.querySelector('.component-country-selector__label')?.classList.toggle('is-float', Boolean(draft.countryCode));
          countrySelector.querySelectorAll('.component-country-selector__item').forEach(item => {
            item.classList.toggle('selected', Boolean(draft.countryCode) && item.dataset.countryCode === draft.countryCode);
          });
          countrySelector.dispatchEvent(new CustomEvent('countryChanged', { detail: { iso2: draft.countryCode || null } }));
        }
        const dialcode = getDialcodeInstance();
        if (dialcode && draft.dialcode) {
          dialcode.closeDropdown();
          dialcode.currentCountry = draft.dialcode.country;
          dialcode.isSelected = draft.dialcode.selected;
          dialcode.updateDisplay();
        }
        supportSelectors.forEach(({ api, input }) => api.setSelected(input.value));
        draftFields.forEach(field => {
          if (field.matches('.component-text-input__field, textarea')) {
            field.dispatchEvent(new Event('input', { bubbles: true }));
            window.TextInputComponent?.clearValidationState?.(field);
            window.hideTextInputError?.(field);
          }
          field.removeAttribute('aria-invalid');
        });
        form.querySelectorAll('[aria-invalid]').forEach(el => el.removeAttribute('aria-invalid'));
        form.querySelectorAll('.component-country-selector__error, .component-dialcode-selector__error, .customer-support-form__message-error').forEach(el => { el.style.display = 'none'; });
        dialcodeContainer?.classList.remove('component-dialcode-selector--error');
        form.querySelector('.customer-support-form__message-wrap')?.classList.remove('customer-support-form__message-wrap--error');
      }
      function selectSupportType(type, updateUrl) {
        if (submitting) return;
        const previousType = supportType;
        drafts[supportType] = captureDraft();
        supportType = type === 'aftersales' ? 'aftersales' : 'presales';
        if (updateUrl && previousType !== supportType) trackSupport('tab_select');
        const aftersales = supportType === 'aftersales';
        form.insertBefore(aftersales ? issueSection : contactSection, form.firstChild);
        if (aftersales) {
          issueSection.append(messageSection);
          issueSection.after(contactSection);
        } else {
          contactSection.after(messageSection);
        }
        document.querySelectorAll('[data-presales-only], [data-aftersales-only]').forEach(el => {
          const visible = el.hasAttribute(aftersales ? 'data-aftersales-only' : 'data-presales-only');
          el.hidden = !visible;
          el.querySelectorAll('input, select, textarea, button').forEach(input => { input.disabled = !visible; });
          el.querySelectorAll('.component-filter__state-layer').forEach(toggle => { toggle.setAttribute('aria-expanded', 'false'); });
          el.querySelectorAll('.component-filter__dropdown').forEach(dropdown => { dropdown.hidden = true; });
        });
        tabs.forEach(tab => {
          const active = tab.dataset.supportType === supportType;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        form.setAttribute('aria-labelledby', 'support-' + supportType + '-tab');
        messageTextarea.maxLength = aftersales ? 1500 : 2000;
        restoreDraft(drafts[supportType]);
        messageTextarea.placeholder = aftersales ? copy.issue : copy.question;
        messageTextarea.setAttribute('aria-label', messageTextarea.placeholder);
        messageTextarea.dispatchEvent(new Event('input', { bubbles: true }));
        form.querySelector('.support-validation-error').hidden = true;
        form.querySelector('#customerSupportResultMessage').style.display = 'none';
        if (updateUrl) {
          const url = new URL(location.href);
          url.searchParams.set('type', supportType);
          history.replaceState(null, '', url);
        }
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectSupportType(tab.dataset.supportType, true));
        tab.addEventListener('keydown', event => {
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : ['ArrowLeft', 'ArrowRight'].includes(event.key) ? 1 - index : -1;
          if (next < 0) return;
          event.preventDefault();
          tabs[next].focus();
          selectSupportType(tabs[next].dataset.supportType, true);
        });
      });
      selectSupportType(new URLSearchParams(location.search).get('type'), false);
      trackSupport('page_view');
      window.addEventListener('popstate', () => selectSupportType(new URLSearchParams(location.search).get('type'), false));
      let formRevision = 0;
      const snField = form.elements.sn;
      let snRevision = 0;
      let pendingSnCheck;
      function checkSn(value) {
        const sn = value.trim().toUpperCase();
        if (pendingSnCheck?.sn === sn) return pendingSnCheck.promise;
        const check = { sn };
        check.promise = Promise.resolve().then(() => window.validateCustomerSupportSn(sn))
          .catch(() => ({ ok: false }))
          .finally(() => { if (pendingSnCheck === check) pendingSnCheck = null; });
        pendingSnCheck = check;
        return check.promise;
      }
      snField.addEventListener('input:clear', () => { snRevision += 1; });
      snField.addEventListener('blur', async event => {
        if (supportType !== 'aftersales' || snField.disabled || submitting ||
            event.relatedTarget?.closest('.component-text-input__clear-btn')) return;
        const value = snField.value.trim();
        const revision = ++snRevision;
        let error = !value ? copy.required : value.length !== 16 ? copy.sn : '';
        // Let the shared input component finish its synchronous blur validation first.
        const validation = error ? await Promise.resolve(null) : await checkSn(value);
        if (revision !== snRevision || supportType !== 'aftersales' || snField.disabled ||
            snField.value.trim() !== value || submitting) return;
        if (validation) error = !validation.ok ? copy.snUnavailable : !validation.exists ? copy.snNotFound : '';
        if (error) {
          window.showTextInputError?.(error, snField);
          snField.setAttribute('aria-invalid', 'true');
        } else {
          window.hideTextInputError?.(snField);
          snField.removeAttribute('aria-invalid');
        }
      });
      form.addEventListener('change', () => { formRevision += 1; });
      form.addEventListener('input', event => {
        formRevision += 1;
        form.querySelector('.support-validation-error').hidden = true;
        if (event.target === form.elements.sn) {
          snRevision += 1;
          window.hideTextInputError?.(event.target);
          event.target.removeAttribute('aria-invalid');
        }
      });


    function scrollToFirstFormError() {
      const candidates = form.querySelectorAll('.component-text-input--error, .component-input-selector--error, .component-dialcode-selector--error, .component-country-selector--error, .partnership-form__choice-group--error, .partnership-form__select-wrapper--error, .customer-support-form__message-wrap--error, [aria-invalid="true"], input:invalid, textarea:invalid, select:invalid');
      let target;
      for (const candidate of candidates) {
        const visible = candidate.type === 'hidden' ? candidate.closest('.component-input-selector') : candidate;
        if (visible && visible.getClientRects().length && getComputedStyle(visible).visibility !== 'hidden' && !candidate.disabled) {
          target = visible;
          break;
        }
      }
      if (!target) return;
      const focusTarget = target.matches('input:not([type="hidden"]), textarea, select, button, [tabindex]')
        ? target : target.querySelector('input:not([type="hidden"]):not(:disabled), textarea:not(:disabled), select:not(:disabled), button:not(:disabled), [tabindex="0"]');
      focusTarget?.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - 120), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

      // 表单提交
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (submitting) return;
        trackSupport('submit_attempt');
        const activeElement = document.activeElement;
        if (activeElement && form.contains(activeElement) && typeof activeElement.blur === 'function') {
          activeElement.blur();
        }

        let hasError = false;

        // First Name 验证
        const firstNameField = form.querySelector('input[name="firstName"]');
        if (firstNameField) {
          const firstNameValue = firstNameField.value?.trim() || '';
          if (!firstNameValue) {
            hasError = true;
            if (window.showTextInputError) {
              window.showTextInputError(messages.fieldRequired, firstNameField);
            }
          } else {
            if (!validateNameField(firstNameField)) {
              hasError = true;
            }
          }
        }

        // Last Name 验证
        const lastNameField = form.querySelector('input[name="lastName"]');
        if (lastNameField) {
          const lastNameValue = lastNameField.value?.trim() || '';
          if (!lastNameValue) {
            hasError = true;
            if (window.showTextInputError) {
              window.showTextInputError(messages.fieldRequired, lastNameField);
            }
          } else {
            if (!validateNameField(lastNameField)) {
              hasError = true;
            }
          }
        }

        // Email 验证
        const emailField = form.querySelector('input[name="email"]');
        if (emailField) {
          const emailValue = emailField.value?.trim() || '';
          if (!emailValue) {
            hasError = true;
            if (window.showTextInputError) {
              window.showTextInputError(messages.fieldRequired, emailField);
            }
          } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(emailValue)) {
              hasError = true;
              if (window.showTextInputError) {
                window.showTextInputError(messages.emailInvalid, emailField);
              }
            } else {
              if (window.hideTextInputError) {
                window.hideTextInputError(emailField);
              }
            }
          }
        }

        // Country 验证（从 Take a Drive 同步）
        const countryField = form.querySelector('input[name="customerSupportCountry_value"]');
        if (countryField) {
          const countryValue = countryField.value?.trim() || '';
          if (!countryValue) {
            // 国家选择器错误显示
            const countrySelector = form.querySelector('#customerSupportCountry');
            if (countrySelector) {
              countrySelector.classList.add('component-country-selector--error');
              // 创建或显示错误消息
              let errorElement = countrySelector.querySelector('.component-country-selector__error');
              if (!errorElement) {
                errorElement = document.createElement('div');
                errorElement.className = 'component-country-selector__error';
                countrySelector.appendChild(errorElement);
              }
              errorElement.textContent = messages.fieldRequired;
              errorElement.style.display = 'block';
            }
            hasError = true;
          } else {
            // 清除国家选择器错误
            const countrySelector = form.querySelector('#customerSupportCountry');
            if (countrySelector) {
              countrySelector.classList.remove('component-country-selector--error');
              const errorElement = countrySelector.querySelector('.component-country-selector__error');
              if (errorElement) {
                errorElement.style.display = 'none';
              }
            }
          }
        }

        // Zip Code 验证（从 Take a Drive 同步）
        const zipCodeField = form.querySelector('input[name="zipCode"]');
        if (zipCodeField && !zipCodeField.disabled) {
          const zipCodeValue = zipCodeField.value?.trim() || '';
          if (!zipCodeValue) {
            hasError = true;
            if (window.showTextInputError) {
              window.showTextInputError(messages.fieldRequired, zipCodeField);
            }
          } else if (zipCodeValue.length > 20) {
            hasError = true;
            if (window.showTextInputError) {
              window.showTextInputError(messages.max20Characters, zipCodeField);
            }
          } else if (window.validator && typeof window.validator.isPostalCode === 'function') {
            const countrySelectorEl = form.querySelector('#customerSupportCountry');
            const iso2 = (countrySelectorEl && countrySelectorEl.getAttribute('data-country-code')) ? countrySelectorEl.getAttribute('data-country-code') : '';
            let isValidZip = true;
            try {
              isValidZip = window.validator.isPostalCode(zipCodeValue, iso2 || 'any');
            } catch (e) {
              // locale 不支持时 fallback
              try {
                isValidZip = window.validator.isPostalCode(zipCodeValue, 'any');
              } catch (err) {
                isValidZip = true;
              }
            }

            if (!isValidZip) {
              hasError = true;
              if (window.showTextInputError) {
                window.showTextInputError(messages.invalidZipCode, zipCodeField);
              }
            } else {
              if (window.hideTextInputError) {
                window.hideTextInputError(zipCodeField);
              }
            }
          } else {
            if (window.hideTextInputError) {
              window.hideTextInputError(zipCodeField);
            }
          }
        }

        // 手机号验证
        if (phoneGroup && window.PhoneWithDialcode && typeof window.PhoneWithDialcode.validate === 'function') {
          if (!window.PhoneWithDialcode.validate(phoneGroup)) {
            hasError = true;
          }
        }

        const categoryValue = supportType === 'aftersales' ? 'AFTER_SALES_SUPPORT' : 'PRODUCT_ORDER_INQUIRIES';
        const extraError = form.querySelector('.support-validation-error');
        extraError.hidden = true;
        extraError.textContent = '';
        let extraMessage = '';
        if (supportType === 'aftersales') {
          for (const fieldName of ['purchaseChannel', 'storeChannelDetails', 'afterSalesIssueType', 'sn']) {
            const field = form.elements[fieldName];
            const value = field.value.trim();
            const error = !value ? copy.required : fieldName === 'sn' && value.length !== 16 ? copy.sn : '';
            field.setAttribute('aria-invalid', error ? 'true' : 'false');
            const selectorToggle = field.closest('.component-input-selector')?.querySelector('.component-filter__state-layer');
            if (selectorToggle) selectorToggle.setAttribute('aria-invalid', error ? 'true' : 'false');
            if (error) {
              hasError = true;
              extraMessage = extraMessage || error;
              if (window.showTextInputError && field.tagName === 'INPUT' && field.type !== 'hidden') window.showTextInputError(error, field);
            }
          }
        }
        if (!form.elements.privacyConsent.checked) {
          hasError = true;
          extraMessage = extraMessage || copy.consent;
        }
        if (messageTextarea.value.length > messageTextarea.maxLength) {
          hasError = true;
          extraMessage = copy.tooLong;
        }
        if (extraMessage) {
          extraError.textContent = extraMessage;
          extraError.hidden = false;
        }

        // Message 验证
        const messageValue = messageTextarea.value?.trim() || '';
        if (!messageValue) {
          hasError = true;
          const messageWrap = messageTextarea.closest('.customer-support-form__message-wrap');
          if (messageWrap) {
            messageWrap.classList.add('customer-support-form__message-wrap--error');
            const errorElement = messageWrap.querySelector('.customer-support-form__message-error');
            if (errorElement) {
              errorElement.textContent = messages.fieldRequired;
              errorElement.style.display = 'block';
            }
          }
        }

        if (hasError) {
          trackSupport('validation_error');
          scrollToFirstFormError();
          return;
        }

        const submitBtn = form.querySelector('.customer-support-form__submit');
        const resultMessageEl = document.getElementById('customerSupportResultMessage');

        // 获取国家码
        const countrySelectorEl = form.querySelector('#customerSupportCountry');
        let countryCode = '';
        
        if (countrySelectorEl) {
          countryCode = countrySelectorEl.getAttribute('data-country-code') || '';
          if (!countryCode) {
            const selectedItem = countrySelectorEl.querySelector('.component-country-selector__item.selected');
            if (selectedItem) {
              countryCode = selectedItem.getAttribute('data-country-code') || '';
            }
          }
        }

        // 构建提交数据
        const phoneSubmissionData = getPhoneSubmissionData();
        const formData = {
          firstName: firstNameField?.value?.trim() || '',
          lastName: lastNameField?.value?.trim() || '',
          email: emailField?.value?.trim() || '',
          country: countryCode,
          zipCode: supportType === 'presales' ? zipCodeField?.value?.trim() || '' : '',
          areaCode: dialcodeInput?.value?.trim() || '',
          phone: phoneSubmissionData.rawPhoneNumber,
          formatPhone: dialcodeInput?.value?.trim()
            ? `${dialcodeInput.value.trim()} ${countryCode === 'US' && /^\d{10}$/.test(phoneSubmissionData.formatPhone)
              ? phoneSubmissionData.formatPhone.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3')
              : phoneSubmissionData.formatPhone}`
            : phoneSubmissionData.formatPhone,
          inquiryCategory: categoryValue,
          message: messageValue
        };

        const apiData = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          country: formData.country,
          zipCode: formData.zipCode,
          areaCode: formData.areaCode,
          phone: formData.phone,
          formatPhone: formData.formatPhone,
          inquiryType: formData.inquiryCategory,
          message: formData.message
        };

        if (supportType === 'aftersales') {
          apiData.purchaseChannel = form.elements.purchaseChannel.value;
          apiData.channelDetail = form.elements.storeChannelDetails.value.trim();
          apiData.afterSalesIssueType = form.elements.afterSalesIssueType.value;
          apiData.sn = form.elements.sn.value.trim();
        }
        submitting = true;
        tabs.forEach(tab => { tab.disabled = true; });
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.setAttribute('aria-busy', 'true');
          const label = submitBtn.querySelector('.component-cta-button__label');
          if (label) {
            submitBtn.dataset.defaultLabel = label.textContent;
            label.textContent = submitBtn.dataset.loadingLabel || 'Loading...';
          }
        }

        if (resultMessageEl) {
          resultMessageEl.textContent = '';
          resultMessageEl.className = 'customer-support-form__result-message';
          resultMessageEl.style.display = 'none';
        }

        try {
          if (supportType === 'aftersales') {
            const revision = formRevision;
            const submittedDraft = JSON.stringify(captureDraft());
            const snField = form.elements.sn;
            const submittedSn = apiData.sn;
            const validation = await checkSn(submittedSn);
            // An edited form requires a new submission and a fresh SN check.
            if (revision !== formRevision || JSON.stringify(captureDraft()) !== submittedDraft || snField.value.trim() !== submittedSn) return;
            if (!validation.ok || !validation.exists) {
              trackSupport(validation.ok ? 'sn_validation_error' : 'sn_validation_unavailable');
              const error = validation.ok ? copy.snNotFound : copy.snUnavailable;
              snField.focus();
              window.showTextInputError?.(error, snField);
              snField.setAttribute('aria-invalid', 'true');
              extraError.textContent = error;
              extraError.hidden = false;
              return;
            }
            window.hideTextInputError?.(snField);
            snField.removeAttribute('aria-invalid');
            apiData.sn = validation.sn;
            snField.value = validation.sn;
          }
          trackSupport('submit');
          const result = await window.submitCustomerSupport(apiData);

          if (result?.code === 200) {
            trackSupport('submit_success');
            // Only the submitted tab is cleared; the other draft stays in memory.
            drafts[supportType] = emptyDraft;
            restoreDraft(emptyDraft);

            // 显示成功提示
            if (resultMessageEl) {
              const successMessage = result?.message ?? '';
              resultMessageEl.textContent = successMessage;
              resultMessageEl.className = 'customer-support-form__result-message customer-support-form__result-message--success';
              if (successMessage) {
                resultMessageEl.style.display = 'block';
                resultMessageEl.removeAttribute('hidden');
              } else {
                resultMessageEl.style.display = 'none';
                resultMessageEl.setAttribute('hidden', 'hidden');
              }
            }
          } else {
            // 失败
            trackSupport('submit_error');
            if (resultMessageEl) {
              resultMessageEl.textContent = result?.message || copy.failed;
              resultMessageEl.className = 'customer-support-form__result-message customer-support-form__result-message--error';
              resultMessageEl.style.display = 'block';
              resultMessageEl.removeAttribute('hidden');
            }
          }
        } catch (error) {
          trackSupport('submit_error');
          const errorMessage = error?.message || copy.failed;
          if (resultMessageEl) {
            resultMessageEl.textContent = errorMessage;
            resultMessageEl.className = 'customer-support-form__result-message customer-support-form__result-message--error';
            resultMessageEl.style.display = 'block';
            resultMessageEl.removeAttribute('hidden');
          }
        } finally {
          submitting = false;
          tabs.forEach(tab => { tab.disabled = false; });
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
            const label = submitBtn.querySelector('.component-cta-button__label');
            if (label && submitBtn.dataset.defaultLabel !== undefined) {
              label.textContent = submitBtn.dataset.defaultLabel;
            }
          }
        }
      });
    }

    // Modal 关闭功能
    const modal = document.getElementById('customerSupportModal');
    if (modal) {
      const closeBtn = modal.querySelector('.customer-support-modal__close');
      const overlay = modal.querySelector('.customer-support-modal__overlay');
      const okBtn = modal.querySelector('.customer-support-modal__btn--primary');

      function closeModal() {
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', closeModal);
      }

      if (overlay) {
        overlay.addEventListener('click', closeModal);
      }

      if (okBtn) {
        okBtn.addEventListener('click', closeModal);
      }

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.style.display === 'flex') {
          closeModal();
        }
      });
    }
  });
